module.exports = __webpack_public_path__ + "fa49e86f74731b079a2ac6c2ceb90a2a.svg";